
import { Form, Field, ErrorMessage, FormActions } from "vee-validate";
import { computed } from "vue";
import _ from "lodash";
import { useStore } from "vuex";
import {
  showFailedRequestToastError,
  showToastSuccess
} from "@/helpers/notification";
import { i18n } from "@/lang";
import { useRoute } from "vue-router";

export default {
  components: { Form, Field, ErrorMessage },

  emits: ["done", "cancel"],

  setup(props: {}, context: { emit: Function }) {
    const route = useRoute();
    const store = useStore();

    const customerInfo = computed(() => store.state.metadata.customerInfo);

    return {
      customerInfo,
      handleSubmit: async (
        values: { [k: string]: string },
        actions: FormActions<any>
      ) => {
        await store
          .dispatch(
            "session/createFeedback",
            _.assign(
              {
                type: "bug-report"
              },
              values,
              JSON.parse((route.query.feedback_payload ?? "{}") as string),
              {
                // client: {
                //   extension: store.getters["auth/deviceId"]
                // }
              }
            )
          )
          .then(() => {
            actions.resetForm();
            showToastSuccess(
              i18n.global.t("feedback.form.notifications.success")
            );
            context.emit("done");
          })
          .catch(err => {
            actions.setErrors(
              (err.response?.data as { errors?: object }).errors ?? {}
            );
            showFailedRequestToastError(err);
          });
      },
      ..._.pick(_, "pick")
    };
  }
};
